// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-a30f2974]:root{--light_text_color:#666}li a[data-v-a30f2974]{display:flex;align-items:center;justify-content:space-between}li span[data-v-a30f2974]{margin-right:5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
